import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=8e510058&scoped=true"
import script from "./SubscriptionView.vue?vue&type=script&lang=js"
export * from "./SubscriptionView.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionView.vue?vue&type=style&index=0&id=8e510058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e510058",
  null
  
)

export default component.exports